class KronVideoControls extends HTMLElement {
  connectedCallback() {
    this._player = this.closest('.hdt-media-overlap-content')?.querySelector('hdt-video-player');
    this._playBtn = this.querySelector('[data-play-pause]');
    this._soundBtn = this.querySelector('[data-sound]');

    if (!this._player) return;

    this._player.addEventListener('media:play',  () => this._setPlayState(true));
    this._player.addEventListener('media:pause', () => this._setPlayState(false));

    this._playBtn?.addEventListener('click', () => {
      this._player.playing ? this._player.pause() : this._player.play();
    });

    this._soundBtn?.addEventListener('click', () => this._toggleMute());

    // Set initial sound state from Liquid-rendered attribute
    if (this._soundBtn) {
      this._setSoundState(this._soundBtn.dataset.muted === 'true');
    }

    // Reflect current play state if already playing
    if (this._player.hasAttribute('playing')) {
      this._setPlayState(true);
    }
  }

  _setPlayState(playing) {
    this._playBtn?.setAttribute('data-playing', playing);
    this._playBtn?.setAttribute('aria-label', playing ? 'Pause' : 'Abspielen');
  }

  _setSoundState(muted) {
    if (!this._soundBtn) return;
    this._soundBtn.setAttribute('data-muted', muted);
    this._soundBtn.setAttribute('aria-label', muted ? 'Ton einschalten' : 'Ton ausschalten');
  }

  _toggleMute() {
    const video = this._player.querySelector('video');
    if (video) {
      video.muted = !video.muted;
      this._setSoundState(video.muted);
      return;
    }

    // External video: try YouTube postMessage (requires enablejsapi=1)
    const iframe = this._player.querySelector('iframe');
    if (iframe) {
      const currentMuted = this._soundBtn?.dataset.muted === 'true';
      const func = currentMuted ? 'unMute' : 'mute';
      iframe.contentWindow?.postMessage(JSON.stringify({ event: 'command', func }), '*');
      this._setSoundState(!currentMuted);
      return;
    }

    // Vimeo via Player API (if loaded)
    if (window.Vimeo?.Player) {
      const vimeoIframe = this._player.querySelector('iframe');
      if (vimeoIframe) {
        const currentMuted = this._soundBtn?.dataset.muted === 'true';
        const vimeoPlayer = new Vimeo.Player(vimeoIframe);
        vimeoPlayer.setMuted(!currentMuted);
        this._setSoundState(!currentMuted);
      }
    }
  }
}

customElements.define('kron-video-controls', KronVideoControls);
